<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Order No：{{ formData.orderNo ? formData.orderNo : "New" }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.planStatus === 'Y' ||
            formData.planStatus === 'P' ||
            formData.planStatus === 'C' ||
            formData.planStatus === 'N'
              ? 'success'
              : formData.planStatus === 'T'
              ? 'warning'
              : formData.planStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_planStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : "--" }} at
          {{ formData.modifyDate ? formData.modifyDate : "--" }}
        </span>
        <el-divider direction="vertical"></el-divider>

        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName ? formData.createByName : "--" }} at
          {{ formData.createDate ? formData.createDate : "--" }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Review：{{ formData.reviewByName ? formData.reviewByName : "--" }} at
          {{ formData.reviewTime ? formData.reviewTime : "--" }}
        </span>
      </div>
    </div>
    <el-form ref="form" :model="formData" :disabled="disabled" size="small">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_Material_plan_No')||'物料计划编号'">
            <el-input
              v-model="formData.mrpMaterialPlanNo"
              type="text"
              maxlength="50"
              show-word-limit
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.table_label_order_no')||'订单编号'">
            <el-input
              v-model="formData.orderNo"
              type="text"
              maxlength="50"
              show-word-limit
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_Material_demand_type')||'物料需求种类'">
            <el-input
              v-model="formData.needKindCount"
              type="text"
              maxlength="11"
              show-word-limit
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_Purchased_category')||'已采购种类'">
            <el-input
              v-model="formData.hasKindCount"
              type="text"
              maxlength="11"
              show-word-limit
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_Received_category')||'已入库种类'">
            <el-input
              v-model="formData.stockKindCount"
              type="text"
              maxlength="11"
              show-word-limit
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_Total_demand_quantity')||'总需求数量'">
            <el-input
              v-model="formData.needTotalQty"
              type="text"
              maxlength="18"
              show-word-limit
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_Total_purchased')||'已采购总数'">
            <el-input
              v-model="formData.hasKTotalQty"
              type="text"
              maxlength="18"
              show-word-limit
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_Total_received')||'已入库总数'">
            <el-input
              v-model="formData.stockTotalQty"
              type="text"
              maxlength="18"
              show-word-limit
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    code: String,
    disabled: Boolean,
  },
  data() {
    return {
      formData: {},
    }
  },
  mounted(){
       this.getData();
  },
  methods:{
    getData() {
      if(!this.code) return;
      this.$api
        .mrpMaterialPlanDetailApi({
          mrpMaterialPlanCode: this.code,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  }
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
